import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoHangDiemBan } from './LoHangDiemBan.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class LoHangDiemBanService extends BaseService{

    DisplayColumns001: string[] = ['STT', 'Name', 'DienThoai', 'DiaChi', 'KinhDo', 'ViDo', 'Note', 'Save'];
        
    List: LoHangDiemBan[] | undefined;
    ListFilter: LoHangDiemBan[] | undefined;
    FormData!: LoHangDiemBan;

    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.Controller = "LoHangDiemBan";
    }
}

